<template>
  <div class="search-item">
    <span v-if="!showEditSearch">
      <a :href="searchUrl + search.search">{{ search.name }}</a>
      <a
        href="#"
        class="edit-search-item"
        @click.prevent="openEditSearch(search.name)"
      ><img src="/images/icons/edit_black_48dp.svg"></a>
      <a
        href="#"
        class="delete-search-item"
        @click.prevent="$emit('deleteSearchItem', search)"
      >
        <img src="/images/icons/delete_black_48dp.svg">
      </a>
    </span>
    <span v-if="showEditSearch">
      <input
        v-model="updatedSearchName"
        class="saved-search-input"
        :ref="`searchInput${index}`"
        type="text"
        maxlength="255"
        required
        @keyup.enter="editSearchItem(search, index)"
        @keyup.escape="closeEditSearch"
      >
      <a
        href="#"
        class="update-search-item"
        @click.prevent="editSearchItem(search, index)"
      >
        <img src="/images/icons/check.svg">
      </a>
      <a
        href="#"
        class="cancel-update-item"
        @click.prevent="showEditSearch = false"
      >
        <img src="/images/icons/icon-remove.46b7f0b2695b.svg">
      </a>
      <div
        v-if="editSearchError"
        class="save-search-error"
      >
        {{ editSearchError }}
      </div>
    </span>
  </div>
</template>

<script>
import axios from 'axios'
import Cookies from 'js-cookie'

export default {
  name: 'SavedSearchItem',
  props: {
    search: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      editSearchError: null,
      searchUrl: window.location.origin + window.location.pathname,
      showEditSearch: false,
      updatedSearchName: ''
    }
  },
  methods: {
    closeEditSearch() {
      this.editSearchError = null
      this.showEditSearch = false
      this.updatedSearchName = ''
    },
    editSearchItem(search, index) {
      this.editSearchError = null
      if (!this.$refs[`searchInput${this.index}`].checkValidity()) {
        this.$refs[`searchInput${this.index}`].reportValidity()
        this.$refs[`searchInput${this.index}`].focus()
        return
      }

      const csrftoken = Cookies.get('csrftoken')
      let searchUpdate = {
        'name': search.name,
        'new_name': this.updatedSearchName,
        'search': search.search
      }
      axios.post('/en/message-search/saved-searches/change/', searchUpdate, {'headers': {'X-CSRFToken': csrftoken}}).then(response => {
        console.log(response)
        this.showEditSearch = false
        let update = {
          name: this.updatedSearchName,
          index: this.index
        }
        this.$emit('searchUpdated', update)
      }).catch((err) => {
        this.editSearchError = err.response.data
      })
    },
    openEditSearch(searchName) {
      this.showEditSearch = true
      this.updatedSearchName = searchName
      this.$nextTick(() => this.$refs[`searchInput${this.index}`].focus())
    }
  }
}
</script>

<style scoped>
.save-search-error {
  color: #a42334;
  margin-top: 5px;
}
</style>